import { NoAccessPage, PageLoading } from '@/components';
import { useEfaxAccess } from '../hooks/useEfaxAccess';

interface EfaxFeatureGateProps {
  children: React.ReactNode;
}

export const EfaxFeatureGate = ({ children }: EfaxFeatureGateProps) => {
  const { canAccess, isLoading } = useEfaxAccess();

  if (isLoading) {
    return <PageLoading />;
  }

  if (!canAccess) {
    return <NoAccessPage />;
  }

  return <>{children}</>;
};
